import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const AosInit = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        AOS.init({
            duration: 500,
            easing: 'ease-out-quad',
            once: true,
            offset: 60,
        });
    }, []);

    useEffect(() => {
        AOS.refreshHard();
    }, [pathname]);

    return null;
};

export default AosInit;
